import {
  LOGOUT,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  HIDE_AUTH_ALERT,
} from '../constants/auth.constants'
import Parse from '../api/parse'
const initialState = {
  isSigningUp: false,
  isLoggingIn: false,
  isLoggedIn: Parse.User.current() ? true : false,
  token: null,
  userId: null,
  error: false,
  errorMessage: '',
}

const auth = (state = initialState, action) => {
  switch (action.type) {
    case SIGNUP_REQUEST:
      return {
        ...state,
        isSigningUp: true,
      }

    case SIGNUP_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        isSigningUp: false,
        userId: action.payload.objectId,
        token: action.payload.sessionToken,
      }

    case SIGNUP_FAILURE:
      return {
        ...state,
        isSigningUp: false,
      }

    case LOGIN_REQUEST:
      return {
        ...state,
        isLoggingIn: true,
      }

    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        userId: action.payload.objectId,
        token: action.payload.sessionToken,
      }

    case LOGIN_FAILURE:
      return {
        ...state,
        error: action.payload.message ? true : false,
        errorMessage: action.payload.message,
        isLoggedIn: false,
        isLoggingIn: false,
      }
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
      }
    case HIDE_AUTH_ALERT:
      return {
        ...state,
        error: false,
        errorMessage: '',
      }
    default:
      return state
  }
}

export default auth
